import axios from '@/libs/api.request'

export const repairGet = (data) => {
  return axios.request({
    url: '/print/repair',
    params: data,
    method: 'get'
  })
}
export const repairSave = data => {
  return axios.request({
    url: '/print/repair',
    data,
    method: 'put'
  })
}
export const SearchRepair = data => {
  return axios.request({
    url: '/print/repair/search',
    params: data,
    method: 'get'
  })
}
export const GetRepairMachine = data => {
  return axios.request({
    url: '/print/repair/machine',
    params: data,
    method: 'get'
  })
}
export const TransferMachine = data => {
  return axios.request({
    url: '/print/repair/machine/transfer',
    data,
    method: 'put'
  })
}
export const DelRenewRepair = data => {
  return axios.request({
    url: '/print/repair/del/renew',
    data,
    method: 'put'
  })
}
